import type { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import { useFelaEnhanced } from '@/hooks';
import type { FormattedMessageProps } from '@/modules/localizations';
import { Heading, Text } from '@/modules/ui';
import type { RulesExtend } from '@/styles/theme';

import * as felaRules from './AlertCard.rules';

export interface AlertCardProps {
    extend?: RulesExtend<typeof felaRules>;
    title: FormattedMessageProps;
    description: FormattedMessageProps;
    footer: ReactNode;
}

export const AlertCard = ({ extend, title, description, footer }: AlertCardProps) => {
    const { styles } = useFelaEnhanced(felaRules, { extend });

    return (
        <article className={styles.container} role='alert'>
            <Heading elementType='h2' variant='h2' customStyle={felaRules.title}>
                <FormattedMessage {...title} />
            </Heading>
            <Text variant='ParagraphSmallMedium' elementType='p' customStyle={felaRules.description}>
                <FormattedMessage {...description} />
            </Text>
            <div className={styles.footer}>{footer}</div>
        </article>
    );
};
